module.exports = __webpack_public_path__ + "static/media/823KennedyStNW_2018-07-09_198.c3ce8fba.jpg";